import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'SignInForm';

/**
 * Errors related to the Create Account page
 */
export const Errors = createErrors<Page, Component>('SignIn')({
    SignInForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to submit the sign in form',
        },
        ValidateCartMerge: {
            severity: 'HIGH',
            message: 'Failed to validate cart merge',
        },
    },
});
